import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, HttpService, Identity } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { AdditionalVisitor, InviteVisitor } from '../widgets/terminal/additional-visitors/additional-visitor.model';

export class VisitorAdditionalVisitorController extends AbstractStepController {

    private httpService: HttpService;
    private nextControl = new StepControl();

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === 'inviteVisitor') {
            this.httpService.postWithContext<InviteVisitor>(environment.registrationInviteAdditionalVisitorEndpoint, contextChange.value).subscribe(result => {
                this.loadAdditionalVisitors();
            });
        }
    }

    onRegisterToDashboardContext() {
        this.httpService = WizardServiceLocator.injector.get(HttpService);
        this.loadAdditionalVisitors();
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('maintain additional visitor started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {

        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();

    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        let spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.close';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        return controls;
    }

    private loadAdditionalVisitors() {
        const identity = new Identity();
        identity.id = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId)
        // Load existing additional visitors
        this.httpService.postWithContext<Array<AdditionalVisitor>>(environment.registrationGetAllAdditionalVisitorEndpoint, identity).subscribe(result => {
            if (result == null) {
                this.dashboardContext.setContextValue('additionalVisitors', new Array<AdditionalVisitor>());
            } else {
                this.dashboardContext.setContextValue('additionalVisitors', new Array<AdditionalVisitor>(...result.map(r => new AdditionalVisitor(r))));
            }
        });
    }
}
